import React from 'react';
import { useUser } from '../context/UserContext';
import { UserIcon, ClockIcon, CheckCircleIcon, HistoryIcon, RefreshCwIcon, MailIcon, CalendarIcon } from 'lucide-react';
import { trackEvent } from '../services/AnalyticsService';
const ProfilePage: React.FC = () => {
  const {
    userData,
    resetUserData
  } = useUser();
  const formatDate = (timestamp: number) => {
    return new Date(timestamp).toLocaleString();
  };
  const handleResetAccount = () => {
    if (window.confirm('Are you sure you want to reset your account? This is for demo purposes only.')) {
      resetUserData();
    }
  };
  return <div className="py-8 md:py-12" data-id="element-896">
      <div className="bg-white rounded-xl shadow-md p-6 mb-6" data-id="element-897">
        <div className="flex items-center mb-6" data-id="element-898">
          <div className="bg-green-100 p-4 rounded-full mr-4" data-id="element-899">
            <UserIcon className="text-green-600" size={24} data-id="element-900" />
          </div>
          <div data-id="element-901">
            <h1 className="text-2xl font-bold" data-id="element-902">{userData.name}</h1>
            <p className="text-gray-600" data-id="element-903">Goal: {userData.goal}</p>
          </div>
        </div>
        {/* Account Information Section */}
        <div className="mb-6" data-id="element-904">
          <h2 className="text-lg font-semibold mb-3 flex items-center" data-id="element-905">
            <MailIcon className="mr-2 text-gray-600" size={18} data-id="element-906" />
            Account Information
          </h2>
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-907">
            <div className="flex items-center mb-2" data-id="element-908">
              <span className="font-medium text-gray-700 w-32" data-id="element-909">Email:</span>
              <span className="text-gray-800" data-id="element-910">{userData.email}</span>
            </div>
            {userData.registrationDate && <div className="flex items-center mb-2" data-id="element-911">
                <span className="font-medium text-gray-700 w-32" data-id="element-912">
                  Registered:
                </span>
                <span className="text-gray-800" data-id="element-913">
                  {formatDate(userData.registrationDate)}
                </span>
              </div>}
            {userData.lastLoginDate && <div className="flex items-center" data-id="element-914">
                <span className="font-medium text-gray-700 w-32" data-id="element-915">
                  Last Login:
                </span>
                <span className="text-gray-800" data-id="element-916">
                  {formatDate(userData.lastLoginDate)}
                </span>
              </div>}
          </div>
        </div>
        <div className="mb-6" data-id="element-917">
          <h2 className="text-lg font-semibold mb-3" data-id="element-918">Human Design</h2>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-919">
            <div className="font-medium text-blue-800" data-id="element-920">
              {userData.humanDesignType}
            </div>
            <p className="text-gray-700 text-sm mt-1" data-id="element-921">
              {userData.humanDesignDescription}
            </p>
          </div>
        </div>
        <div data-id="element-922">
          <h2 className="text-lg font-semibold mb-3" data-id="element-923">Your Principles</h2>
          <div className="space-y-2" data-id="element-924">
            {userData.values?.map(value => <div key={value} className="bg-purple-50 border border-purple-200 rounded-lg p-3" data-id="element-925">
                <div className="font-medium text-purple-800" data-id="element-926">
                  {value.charAt(0).toUpperCase() + value.slice(1)}
                </div>
                <p className="text-gray-700 text-sm" data-id="element-927">
                  {userData.valueDescriptions?.[value].split(': ')[1]}
                </p>
              </div>)}
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6 mb-6" data-id="element-928">
        <h2 className="text-lg font-semibold mb-4 flex items-center" data-id="element-929">
          <HistoryIcon className="mr-2 text-indigo-600" size={20} data-id="element-930" />
          Quest History
        </h2>
        {userData.completedQuests && userData.completedQuests.length > 0 ? <div className="space-y-3" data-id="element-931">
            {userData.completedQuests.map(questId => <div key={questId} className="flex items-center" data-id="element-932">
                <CheckCircleIcon className="text-green-500 mr-3" size={16} data-id="element-933" />
                <span className="text-gray-700" data-id="element-934">
                  {questId.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                </span>
              </div>)}
          </div> : <p className="text-gray-500 text-center py-4" data-id="element-935">
            No completed quests yet
          </p>}
      </div>
      <div className="bg-white rounded-xl shadow-md p-6" data-id="element-936">
        <h2 className="text-lg font-semibold mb-4 flex items-center" data-id="element-937">
          <ClockIcon className="mr-2 text-indigo-600" size={20} data-id="element-938" />
          Mood History
        </h2>
        {userData.moodHistory && userData.moodHistory.length > 0 ? <div className="space-y-3" data-id="element-939">
            {userData.moodHistory.map((entry, index) => <div key={index} className="flex justify-between items-center" data-id="element-940">
                <span className="text-gray-700" data-id="element-941">{entry.mood}</span>
                <span className="text-gray-500 text-sm" data-id="element-942">
                  {formatDate(entry.timestamp)}
                </span>
              </div>)}
          </div> : <p className="text-gray-500 text-center py-4" data-id="element-943">
            No mood check-ins yet
          </p>}
      </div>
      <div className="mt-8 text-center" data-id="element-944">
        <button onClick={handleResetAccount} className="flex items-center justify-center mx-auto text-red-600 hover:text-red-800" data-id="element-945">
          <RefreshCwIcon size={16} className="mr-1" data-id="element-946" />
          Reset Profile (For Demo)
        </button>
      </div>
    </div>;
};
export default ProfilePage;